<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        
        <v-btn absolute dark bottom fab right color="success" to="/slides/new" v-if="!getLoadingStatus">
          <v-icon>mdi-plus</v-icon>
        </v-btn>        

        <div class="text-center" v-if="getLoadingStatus">
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>

        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Картинка</th>
                <th class="text-left">Комната</th>
                <th class="text-left" v-if="userIsAuthenticated">Удалить</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="slide in slides" :key="slide.id">
                <td><img :src="slide.image" width="50"></td>
                <td>{{ slide.room }}</td>
                <td v-if="userIsAuthenticated">
                  <v-btn icon color="red lighten-3" @click="deleteSlide(slide.id)">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        
      </v-col>
    </v-row> 
  </v-container>
</template>

<script>

  export default {
    data: () => ({

    }),
    methods:{
      deleteSlide(id){
        this.$store.dispatch('deleteSlide', id);
      }
    },
    computed: {
      slides(){
        return this.$store.getters.loadedSlides;
      },
      getLoadingStatus(){
        return this.$store.state.loading;
      },
      userIsAuthenticated(){
        this.$store.dispatch('userIsAuthenticated');
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
      }
    },
    created(){
      this.$store.dispatch('loadSlides');
    }
  }

</script>
